const getHoursFromNow = {
  hours: 'hours left',
  minutes: 'min left'
};

export default getHoursFromNow;
